// extracted by mini-css-extract-plugin
export var actions = "style-module--actions--241a3";
export var added = "style-module--added--8759d";
export var atcButton = "style-module--atcButton--60eb4";
export var contents = "style-module--contents--3e527";
export var hydrated = "style-module--hydrated--e31bd";
export var image = "style-module--image--5a26d";
export var minicart = "style-module--minicart--bc486";
export var mobile = "style-module--mobile--7ca25";
export var name = "style-module--name--04816";